import {gql, useLazyQuery} from '@apollo/client';
import React, {useCallback, useEffect, useMemo} from 'react';
import {debounce} from 'lodash-es';
import AutoField, {ActionType, SelectAutocompleteField} from '../AutoForm/AutoFieldNew';
import {STAFF} from '../../graphql/fragments';
import {SearchStaff, SearchStaffVariables} from '../../schema-types/SearchStaff';
import {useAutoField} from '../AutoForm/useAutoForm';

export const StaffSearchInput: React.FC<{businessUnitIds: string[] | null}> = ({
  businessUnitIds = [],
}) => {
  const [{value: searchTerm}] = useAutoField<string | undefined>('staffSearchTerm');
  const [_onSearch, {data, loading}] = useLazyQuery<
    SearchStaff,
    SearchStaffVariables
  >(gql`
    query SearchStaff($search: String!, $businessUnitIds: [UUID!]) {
      allStaff(businessUnitIds: $businessUnitIds, search: $search, everything: false) {
        ...Staff
      }
    }
    ${STAFF}
  `);
  const onSearch = useCallback(debounce(_onSearch, 500), [_onSearch]);
  useEffect(() => {
    if (searchTerm && searchTerm.length > 2) {
      onSearch({
        variables: {
          search: searchTerm,
          businessUnitIds: businessUnitIds?.length ? businessUnitIds : null,
        },
      });
    }
  }, [searchTerm, businessUnitIds]);
  const searchField = useMemo(() => {
    const field: SelectAutocompleteField = {
      type: ActionType.selectAutocomplete,
      id: 'staff',
      label: 'Search for staff member...',
      fullWidth: true,
      size: 'medium',
      options:
        data?.allStaff?.map((x) => ({
          label: `${x!.firstName!} ${x!.lastName!}`,
          value: x!.id as any,
          group: x!.businessUnit?.name || 'No business unit',
        })) || [],
      serverSearch: {
        // fn: async (search) => {
        //   return onSearch({
        //     variables: {
        //       search,
        //       businessUnitIds: businessUnitIds?.length ? businessUnitIds : null,
        //     },
        //   });
        // },
        inputFormKey: 'staffSearchTerm',
      },
    };
    return field;
  }, [data, onSearch, businessUnitIds]);

  return <AutoField loading={loading} field={searchField} />;
};
